import React from 'react';
import EVCInstall from '../assets/evcinstall.jpeg'
import '../App.css';
import {redirectToCalendly} from './Helpers'

const headlineText = "Effortlessly Upgrade Your Property and Tenant Experience with Gridspot's Electric Vehicle Charging as a Service";

export default function HeaderMgSvc() {
  return (
    <section className="page-hero">
      <div className="container">
        <h1><span className="text-brand">Gridspot</span> Managed Service</h1>
        <p className="lead">{headlineText}</p>
        <div className="page-hero-actions">
          <button type="button" className="btn btn-primary" onClick={redirectToCalendly}>Get Started</button>
          <a className="btn btn-text" href="#installation">Learn More ↓</a>
        </div>
        <div className="install-card" id="installation">
          <img src={EVCInstall} alt="Electrician installing a Gridspot EV charger" width="1480" height="988"/>
          <div className="install-card-text">
            <h2>Installation</h2>
            <p>We handle everything: electrical infrastructure upgrades, parking lot markings, etc. No additional hidden costs to property managers or building owners.</p>
          </div>
        </div>
      </div>
    </section>
  )
}
